import { callApi, IApiErrorResponse } from '@/api/callApi';
import { API_ENDPOINT, API_URL } from '@/api/constant';
import ErrorMessage from '@/components/common/ErrorMessage';
import FieldLayout from '@/components/Layout/FieldLayout';
import Button from '@/components/ui/Button';
import Label from '@/components/ui/Label';
import SearchSelectBox, {
  ISelectOption,
} from '@/components/ui/SearchSelectBox';
import { IEmployeeOnBoardResponse } from '@/interfaces/employee.model';
import { RootState } from '@/redux/store';
import { showToastNotification } from '@/utility/helper';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Modal, ModalBody, Spinner } from 'reactstrap';

interface ITransferModalProps {
  isOpen: boolean;
  toggle: () => void;
  submitHandler: (assignedId: string) => void;
  isLoading: boolean;
}

const TransferModal = ({
  isOpen,
  toggle,
  submitHandler,
  isLoading,
}: ITransferModalProps) => {
  const [selectedUserId, setSelectedUserId] = useState<string>('');
  const [error, setError] = useState<string>('');
  const [isUserLoading, setIsUserLoading] = useState(false);
  const [userList, setUserList] = useState<ISelectOption[]>([]);
  const userdetails = useSelector((state: RootState) => state?.user?.user);
  const getEmployeeList = async () => {
    try {
      setIsUserLoading(true);
      const response: IEmployeeOnBoardResponse = await callApi(
        API_URL + API_ENDPOINT.getEmployee,
        { method: 'GET' },
      );
      if (response?.status) {
        const newData = response?.data?.user
          ?.map((item) => ({
            label: item?.name,
            value: item?.id,
          }))
          ?.filter((item) => item?.value !== userdetails?.id);
        setUserList(newData);
      }
    } catch (error: unknown) {
      if (error && typeof error === 'object' && 'message' in error) {
        showToastNotification('danger', (error as IApiErrorResponse).message);
      } else {
        showToastNotification('danger', 'Something went wrong');
      }
    } finally {
      setIsUserLoading(false);
    }
  };

  useEffect(() => {
    if (isOpen) {
      getEmployeeList();
    }
  }, [isOpen]);
  const handleSubmit = () => {
    if (!selectedUserId) {
      setError('Please select a user');
      return;
    }
    submitHandler(selectedUserId);
    setSelectedUserId('');
    setError('');
    // toggle();
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered>
      <div className="modal-header p-4">
        <h1 className="modal-title fs-3 rajdhani-semibold">Transfer Asset</h1>
        <button
          type="button"
          className="btn-close"
          onClick={() => {
            setError('');
            setSelectedUserId('');
            toggle();
          }}
        />
      </div>
      <ModalBody className="p-4">
        <div className="d-flex flex-column gap-3">
          {/* <FieldLayout>
                        <Label required={true} id="userSelect">
                            Select User
                        </Label>
                        <SearchSelectBox

                            value={selectedUserId}
                            title="Select User"
                            onChange={(option) => {
                                setSelectedUserId(option?.value || '');
                                setError('');
                            }}
                            disable={isUserLoading}
                            isAsync={false}
                            options={userList}
                            isUsingFilter
                        />
                        <ErrorMessage message={error} />
                    </FieldLayout> */}
          <div style={{ width: '100%' }}>
            <FieldLayout>
              <Label required={true} id="userSelect">
                Select User
              </Label>

              <SearchSelectBox
                value={selectedUserId}
                title="Select User"
                onChange={(option) => {
                  setSelectedUserId(option?.value || '');
                  setError('');
                }}
                disable={isUserLoading}
                isAsync={false}
                options={userList}
                isUsingFilter
              />

              <ErrorMessage message={error} />
            </FieldLayout>
          </div>

          <div className="row m-0 w-100 mt-3">
            <div className="col-12 col-md-6 ps-0 pe-3">
              <button
                type="button"
                className="btn btn-danger w-100"
                onClick={toggle}
              >
                Cancel
              </button>
            </div>
            <div className="col-12 col-md-6 pe-0 ps-3">
              <Button
                className="btn btn-primary w-100"
                onClick={handleSubmit}
                disabled={isLoading || isUserLoading}
                type="button"
              >
                {isLoading ? <Spinner size="sm" color="light" /> : 'Transfer'}
              </Button>
            </div>
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default TransferModal;
